import { Tooltip } from "@material-ui/core";
import * as React from "react";
import styled from "styled-components";

interface AdInformationProps {
  adId: string;
  title: string;
  description: string;
  adDuration: number;
}

export const AdInformation: React.FC<AdInformationProps> = ({
  adId,
  title,
  description,
  adDuration,
}) => {
  return (
    <StyledInfoContainer>
      <StyledInfoContent>
        <LabelRow>
          <Label>ID:</Label>
          <Value>{adId}</Value>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Título:</Label>
          <Tooltip title={title} aria-label={title} arrow>
            <Value>{title}</Value>
          </Tooltip>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Descrição:</Label>
          <Tooltip title={description} aria-label={description} arrow>
            <Value>{description}</Value>
          </Tooltip>
        </LabelRow>
        <Hr />
        <LabelRow>
          <Label>Duração AD:</Label>
          <Value>{adDuration}s</Value>
        </LabelRow>
      </StyledInfoContent>
    </StyledInfoContainer>
  );
};

// Estilos
const StyledInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background-color: #D9D9D9;
  border-radius: 3px 3px 0px 0px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: "Roboto","Montserrat";
  height: 210px;
`;

const StyledInfoContent = styled.div`
  display: grid;
  grid-template-columns: min-content;
  /*gap: 8px 16px;*/
  width: 100%;
  max-width: 600px;
  background: #D9D9D9;
  padding: 16px;
  font-family: "Roboto","Montserrat";
`;

const LabelRow = styled.div`
  display: contents;
`;

const Label = styled.div`
  font-weight: bold;
  color: #5B5B5B;
  width: 125px;
  padding: 8px 0px;
`;

const Value = styled.div`
  color: #5B5B5B;
  text-overflow: ellipsis;
  padding: 8px 0px;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  height: 40px;
`;

const Hr = styled.div`
  grid-column: span 2;
  border-bottom: 1px solid  #B1B1B1;
  margin: 1px 0;
`;
